var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L11.7536 15.2916C11.4521 15.3965 11.25 15.6808 11.25 16H12ZM35 35V35.75H35.75V35H35ZM35 16H35.75C35.75 15.6808 35.5479 15.3965 35.2464 15.2916L35 16ZM23.5 12L23.7464 11.2916C23.5868 11.2361 23.4132 11.2361 23.2536 11.2916L23.5 12ZM1 35H0.25V35.75H1V35ZM1 7L0.743693 6.29516L0.25 6.47468V7H1ZM17.5 1L17.8046 0.314641L17.5281 0.191742L17.2437 0.295155L17.5 1ZM31 7H31.75C31.75 6.70361 31.5754 6.43502 31.3046 6.31464L31 7ZM31 14.6087L30.7536 15.3171V15.3171L31 14.6087ZM11.25 16V35H12.75V16H11.25ZM35.75 35V16H34.25V35H35.75ZM12 35.75H23.5V34.25H12V35.75ZM23.5 35.75H35V34.25H23.5V35.75ZM22.75 12V35H24.25V12H22.75ZM12 34.25H1V35.75H12V34.25ZM1.75 35V7H0.25V35H1.75ZM1.25631 7.70484L17.7563 1.70485L17.2437 0.295155L0.743693 6.29516L1.25631 7.70484ZM17.1954 1.68536L30.6954 7.68536L31.3046 6.31464L17.8046 0.314641L17.1954 1.68536ZM35.2464 15.2916L31.2464 13.9003L30.7536 15.3171L34.7536 16.7084L35.2464 15.2916ZM31.2464 13.9003L23.7464 11.2916L23.2536 12.7084L30.7536 15.3171L31.2464 13.9003ZM30.25 7V14.6087H31.75V7H30.25ZM23.2536 11.2916L17.5036 13.2916L17.9964 14.7084L23.7464 12.7084L23.2536 11.2916ZM17.5036 13.2916L11.7536 15.2916L12.2464 16.7084L17.9964 14.7084L17.5036 13.2916ZM18.4999 13.9856L18.2499 0.98558L16.7501 1.01442L17.0001 14.0144L18.4999 13.9856Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.2093L8.94118 8.60465L13.8824 7M4 15.0233L13.8824 11.814M4 19.8372L8.94118 18.2326M4 24.1163L8.94118 22.5116M4 28.9302L8.94118 27.3256M28.1569 9.67442L20.4706 7M16.0784 21.4419L21.0196 19.8372M16.0784 25.7209L21.0196 24.1163M32 21.4419L27.0588 19.8372M32 25.7209L27.0588 24.1163M32 30L27.0588 28.3953M16.0784 30L21.0196 28.3953",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplace);
export default __webpack_public_path__ + "static/media/Workplace.50666414d30bfa64604fecd4a9b40b90.svg";
export { ForwardRef as ReactComponent };